import { Feature } from './types';
import { State as AppState } from '..';

export const selectFeature = (key: Feature) => (state: AppState): boolean => state
  .features[key] || false;
